/**
 * Replaying flex-wrap in JS.
 *
 * A wrapping list that collapses past N lines has to know *which* items were
 * cut, and the browser never says: CSS can clamp the lines, but the count of
 * what fell off the end is not something it exposes. So the caller measures the
 * items once with everything rendered and hands the widths here.
 *
 * Note this assumes the "N more" control lives outside the wrapping box (its own
 * line, say). A toggle sharing the last line takes room of its own, and can push
 * out the very item that made it necessary — that needs a wider search than this.
 */

/** How many of `widths` fit in `lines` rows of `max` px, separated by `gap`. */
export function wrappedCount(widths: number[], max: number, gap: number, lines: number): number {
  let line = 1;
  let used = 0;
  let count = 0;
  for (const width of widths) {
    if (used === 0) {
      // An empty line takes the item whatever its width — an item too wide to
      // fit anywhere overflows its line rather than wrapping forever.
      used = width;
    } else if (used + gap + width > max) {
      line += 1;
      if (line > lines) break;
      used = width;
    } else {
      used += gap + width;
    }
    count += 1;
  }
  return count;
}
